import { render, staticRenderFns } from "./UserPasskeys.vue?vue&type=template&id=1bb49b52&scoped=true&"
import script from "./UserPasskeys.vue?vue&type=script&setup=true&lang=ts&"
export * from "./UserPasskeys.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb49b52",
  null
  
)

export default component.exports